export interface TorneoTipoJSON {
  tt_id: string | null;
  tt_nombre: string;
  tt_activo: boolean;
  tt_requiere_definicion_torneo: boolean;
}

export class TorneoTipo {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private activo: boolean,
    private tt_requiere_definicion_torneo: boolean
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    activo: boolean,
    tt_requiere_definicion_torneo: boolean
  ) {
    return new this(id, nombre, activo, tt_requiere_definicion_torneo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TorneoTipo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TorneoTipoJSON) {
    return TorneoTipo.createFrom(
      entity.tt_id,
      entity.tt_nombre,
      entity.tt_activo,
      entity.tt_requiere_definicion_torneo
    );
  }

  toJSON(): TorneoTipoJSON {
    return {
      tt_id: this.getId(),
      tt_nombre: this.getNombre(),
      tt_activo: this.getActivo(),
      tt_requiere_definicion_torneo: this.getRequiereDefinicionTorneo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getActivo(): any {
    return this.activo;
  }

  getRequiereDefinicionTorneo(): boolean {
    return this.tt_requiere_definicion_torneo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }

  isGrilla() {
    return !!this.nombre.includes('Grilla');
  }

  isTodosvsTodos() {
    return this.nombre === 'Todos contra todos';
  }
  isCombinado() {
    return this.nombre === 'Combinado';
  }
}
